module.exports = __webpack_public_path__ + "img/phone_line.aba39c00.png";